/* Bistrot at Wild Honey */

/**
    * Sticky Header inteligente
    * Last update: 2026-01-13
    * Author: PINHA®
    * © 2026
    */
document.addEventListener('DOMContentLoaded', function () {
    var headers = Array.prototype.slice.call(
        document.querySelectorAll('.WH__site-header')
    );
    if (!headers.length) { return; }

    var isVisible = function (el) {
        return el && el.offsetParent !== null;
    };

    var activeHeader = headers.find(isVisible) || headers[0];
    var lastScrolledState = null;

    var offset = 200;

    var update = function () {
        var scrolled = window.scrollY > offset;
        if (scrolled === lastScrolledState) { return; }
        activeHeader.classList.toggle('is-scrolled', scrolled);
        lastScrolledState = scrolled;
    };

    var pickActiveHeader = function () {
        var next = headers.find(isVisible) || headers[0];
        if (next === activeHeader) { return; }

        activeHeader.classList.remove('is-scrolled');
        activeHeader = next;
        lastScrolledState = null;
        update();
    };

    var ticking = false;
    var onScroll = function () {
        if (ticking) { return; }
        ticking = true;

        requestAnimationFrame(function () {
            update();
            ticking = false;
        });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', pickActiveHeader);

    pickActiveHeader();
    update();
});